import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getPublicPersona } from '../services/apiService';
import ChatPage from './ChatPage';
import styles from './EmbedPage.module.css';

function EmbedPage() {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  const [personaData, setPersonaData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!username) {
      setError('No username provided for the widget.');
      setIsLoading(false);
      return;
    }

    const fetchPersona = async () => {
      try {
        const data = await getPublicPersona(username);
        setPersonaData(data);
      } catch (e) {
        setError('Persona not found or is not public.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPersona();
  }, [username]);

  if (isLoading) {
    return <div className={styles.statusText}>Loading Persona...</div>;
  }

  if (error) {
    return <div className={styles.statusText}>{error}</div>;
  }

  return (
    <div className={styles.embedWrapper}>
      <ChatPage mode="public" publicPersonaData={personaData} view="embedded" />
    </div>
  );
}

export default EmbedPage;
